import { Component } from 'react'
import './styles.sass'

interface Props {
    name: string,
    label?: (() => JSX.Element) | string,
    disabled?: boolean,
    readonly?: boolean,
    checked?: boolean,
    onChange: (value: any) => any
}

export default class CheckboxInput extends Component<Props> {
    // state: any = {   
    //     currentValue: []
    // }

    // componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, snapshot?: any): void {
    //     if(prevProps.value !== this.props.value) {
    //         let currentValue: any = this.props.value;

    //         if(this.props.single) {
    //             currentValue = this.props.value ? [this.props.value] : [];
    //         };

    //         this.setState({ currentValue });
    //     };
    // }

    onSelect = () => {
        // let currentValue = 
        // this.state.currentValue.includes(option.value) ?
        // [...this.state.currentValue].filter(x => x !== option.value) :
        // [...this.state.currentValue, option.value];

        // this.setState({ currentValue }, () => {
        //     this.props.onChange && this.props.onChange(this.props.single ? this.state.currentValue.join() : this.state.currentValue);
        // });
        this.props.onChange(!this.props.checked);
    }

    render() {
        return (
            <div className={'checkbox-container noselect '+(this.props.disabled ? 'disabled' : '')} onClick={this.onSelect}>
                <input
                name={this.props.name}
                type='checkbox'
                disabled={this.props.disabled}
                checked={this.props.checked}
                readOnly />
                {this.props.label && <label>{typeof this.props.label == 'string' ? this.props.label : this.props.label()}</label>}
            </div>
        )
    }
}
